import { clsx } from 'clsx'

import LottieAnimation, {
  LottieAnimationData,
} from 'components/common/LottieAnimation'

import { RatingDialogSize } from './RatingDialog'

const FIVE_STAR_RATING = 100
const FOUR_STAR_RATING = 80

const loadFiveStarCelebration = () =>
  import('./animations/meal_review_celebration_five_star.json')
const loadFourStarCelebration = () =>
  import('./animations/meal_review_celebration_four_star.json')
const loadOneToThreeStarCelebration = () =>
  import('./animations/meal_review_celebration_one_to_three_star.json')

function getRatingCelebrationAnimationLoader(
  rating: number,
): () => Promise<LottieAnimationData> {
  if (rating >= FIVE_STAR_RATING) {
    return loadFiveStarCelebration
  }

  if (rating >= FOUR_STAR_RATING) {
    return loadFourStarCelebration
  }

  return loadOneToThreeStarCelebration
}

const RatingSubmittedCard = ({
  dialogSize = 'singleMeal',
  rating,
}: {
  dialogSize?: RatingDialogSize
  rating: number
}) => {
  const loadAnimationData = getRatingCelebrationAnimationLoader(rating)

  return (
    <div
      className={clsx(
        'text-center',
        dialogSize === 'multiMeal'
          ? 'p-6 md:px-4 md:pb-8 md:pt-4'
          : 'px-4 pb-8 pt-4',
      )}
    >
      {rating >= FOUR_STAR_RATING ? (
        <div className="mx-auto h-[70px] w-[208px]">
          <LottieAnimation loadAnimationData={loadAnimationData} />
        </div>
      ) : (
        <>
          {/* The check mark is a 195px circle centered on a 600x200 canvas, so
              the canvas is sized to render the circle at the designed 50px. */}
          <div className="mx-auto h-[51px] w-[154px]">
            <LottieAnimation loadAnimationData={loadAnimationData} />
          </div>
          <p className="mt-2.5 text-[35px] font-semibold leading-[35px] text-orange-2">
            Thank you
          </p>
        </>
      )}

      <h2 className="mt-[35px] text-k/24_120">Your feedback matters!</h2>
      <p className="mt-3 text-k/20_110 text-grey-10">
        Our menu team carefully reads reviews to curate our weekly menu.
      </p>
    </div>
  )
}

export default RatingSubmittedCard
